export function parseVehicleDoorTrim(trim: string) {
  const doorIndex = trim.indexOf('dr')
  const doorNumber = trim.slice(doorIndex - 1, doorIndex)

  const newString = trim.replace(
    /(\d[dr]\w)/gi,
    `<abbr title="${doorNumber} door">$1</abbr>`,
  )

  return newString
}
